export type Formatter<T> = (value: T | any) => T;

export const plateNumberFormatter: Formatter<string> = (value: string): string => {
  let val = value.toUpperCase();

  // Remove everything except digits and allowed letters
  val = val.replace(/[^0-9А-ЯЁҮӨ]/g, "");

  // Separate digits and letters
  const digits = val.slice(0, 4).replace(/[^0-9]/g, "");
  let letters = val.slice(4);

  if (letters.startsWith("ДК")) {
    letters = letters.slice(0, 2).replace(/[^ДК]/g, "");
  } else {
    letters = letters.slice(0, 3).replace(/[^А-ЯЁҮӨ]/g, "");
  }

  return digits + letters;
};

export const durationFormatter: Formatter<string> = (value: number): string => {
  const totalSeconds = Math.floor(value / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};
